import formatNumber from '@framework/data-helpers/formatters/formatNumber';

interface INumberCellProps {
  value: number | null | undefined,
  decimals?: number,
  rounded?: boolean,
  thousandsSeparator?: string,
}

const NumberCell = ({ value, decimals = 2, rounded, thousandsSeparator = ',' }: INumberCellProps) => {
  if (value === null || value === undefined) {
    return (<>-</>);
  }

  if (rounded) {
    const formatted = formatNumber(Math.round(value), { thousandsSeparator });
    return (<>{ formatted }</>);
  }

  const formatted = formatNumber(value, { decimals, thousandsSeparator });
  return (<>{ formatted }</>);
};

export default NumberCell;
